// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__TCOir","topContainer":"styles_topContainer__iOLI0"};